var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "product column is-one-quarter-tablet is-half-mobile",
      class: _vm.productData.tags,
    },
    [
      _vm.productData.saleprice
        ? _c("div", { staticClass: "onsale" }, [
            _vm._v("\n    " + _vm._s(_vm.languageStrings.sale) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _vm.productData.stock === "outofstock" &&
        _vm.languageStrings.out_of_stock
          ? _c("div", { staticClass: "outofstock-badge" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.languageStrings.out_of_stock) + "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.productData.imgsrc
          ? _c("a", { attrs: { href: _vm.productData.url } }, [
              _c("div", { staticClass: "product-image" }, [
                _c("img", {
                  attrs: {
                    src: _vm.productData.imgsrc,
                    srcset: _vm.productData.imgsrcset,
                    sizes: "(max-width: 50em) 87vw, 680px",
                    alt: _vm.productData.imagealt,
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.productData.url } }, [
          _c("div", { staticClass: "product-description__wrapper" }, [
            _vm.productData.name
              ? _c("div", { staticClass: "product-name" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.productData.name) + "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.productData.specs
              ? _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.productData.specs) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.productData.pricehtml
              ? _c("div", {
                  staticClass: "price",
                  domProps: { innerHTML: _vm._s(_vm.productData.pricehtml) },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product__cta" }, [
            _vm.languageStrings.choose_product && _vm.productData.designer > 0
              ? _c(
                  "div",
                  { staticClass: "button", attrs: { role: "button" } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.languageStrings.choose_product) +
                        "\n        "
                    ),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "button", attrs: { role: "button" } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.languageStrings.show_product) +
                        "\n        "
                    ),
                  ]
                ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }